import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_som_list_item = _resolveComponent("som-list-item")!
  const _component_som_list = _resolveComponent("som-list")!
  const _component_som_header = _resolveComponent("som-header")!

  return (_openBlock(), _createBlock(_component_som_header, {
    "home-link": "/",
    "app-name": "PLACE Plot",
    "department-name": "The MiSTEM Network",
    "main-content-id": "headerMenu",
    breakpoint: "none",
    sticky: "false"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_som_list, {
        slot: "header-menu",
        type: "header",
        role: "navigation"
      }, {
        default: _withCtx(() => [
          (_ctx.isAdmin && !_ctx.loading)
            ? (_openBlock(), _createBlock(_component_som_list_item, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: "/admin" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Surveys")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isAdmin && !_ctx.loading)
            ? (_openBlock(), _createBlock(_component_som_list_item, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: "/admin/regions" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Regions")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isAdmin && !_ctx.loading)
            ? (_openBlock(), _createBlock(_component_som_list_item, { key: 2 }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_link, { to: "/admin/users" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Users")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isAuthenticated)
            ? (_openBlock(), _createBlock(_component_som_list_item, { key: 3 }, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    style: {"cursor":"pointer"},
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.logout && $setup.logout(...args)))
                  }, "Logout")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}